export const BUDGET_TYPE_ID_MONTHLY = 1;
export const BUDGET_TYPE_ID_EVENT = 2;
